export const config = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
};
